import { render, staticRenderFns } from "./Opinion.vue?vue&type=template&id=c0b1f67c&scoped=true&"
import script from "./Opinion.vue?vue&type=script&lang=js&"
export * from "./Opinion.vue?vue&type=script&lang=js&"
import style0 from "./Opinion.vue?vue&type=style&index=0&id=c0b1f67c&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b1f67c",
  null
  
)

export default component.exports